import { ViewIcon } from "@chakra-ui/icons";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  FormControl,
  Input,
  useToast,
  Box,
  IconButton,
  Spinner,
} from "@chakra-ui/react";
import axios from "axios";
import { useState } from "react";
import { ChatState } from "../../context/chatProvider";
import UserBadgeItem from "../userAvatar/UserBadgeItem";
import UserListItem from "../userAvatar/UserListItem";
import EnvRoute from '../../middleware/envRoute';
import GroupIcon from "./GroupIcon";

const ENDPOINT = EnvRoute('prod'); 

const UpdateGroupChatModal = ({ fetchMessages, fetchAgain, setFetchAgain }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [groupChatName, setGroupChatName] = useState();
  const [search, setSearch] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [loading, setLoading] = useState(false);
  const [renameloading, setRenameLoading] = useState(false);
  const toast = useToast();

  const { selectedChat, setSelectedChat, user } = ChatState();

  const handleSearch = async (query) => {
    setSearch(query);
    if (!query) {
      return;
    }

    try {
      setLoading(true);
      const config = {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      };
      const data  = await axios.get(`${ENDPOINT}/api/user?search=${search}`, config);
      console.log('update group modal',data.data);
      setLoading(false);
      setSearchResult([...data.data]);
    } catch (error) {
      toast({
        title: "Error Occured!",
        description: "Failed to Load the Search Results",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
      setLoading(false);
    }
  };

  const handleRename = async () => {
    if (!groupChatName) return;

    try {
      setRenameLoading(true);
      const config = {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      };
      const { data } = await axios.put(
        `${ENDPOINT}/api/chat/rename`,
        {
          chatId: selectedChat._id,
          chatName: groupChatName,
        },
        config
      );

      console.log(data._id);
      // setSelectedChat("");
      setSelectedChat(data);
      setFetchAgain(!fetchAgain);
      setRenameLoading(false);
    } catch (error) {
      toast({
        title: "Error Occured!",
        description: error.response.data.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setRenameLoading(false);
    }
    setGroupChatName("");
  };

  const handleAddUser = async (user1) => {
    if (selectedChat.users.find((u) => u._id === user1._id)) {
      toast({
        title: "User Already in group!",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      return;
    }

    if (selectedChat.groupAdmin._id !== user._id) {
      toast({
        title: "Only admins can add someone!",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      return;
    }

    try {
      setLoading(true);
      const config = {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      };
      const { data } = await axios.put(
        `${ENDPOINT}/api/chat/groupadd`,
        {
          chatId: selectedChat._id,
          userId: user1._id,
        },
        config
      );

      setSelectedChat(data);
      setFetchAgain(!fetchAgain);
      setLoading(false);
    } catch (error) {
      toast({
        title: "Error Occured!",
        description: error.response.data.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setLoading(false);
    }
    setGroupChatName("");
  };

  const handleRemove = async (user1) => {
    if (selectedChat.groupAdmin._id !== user._id && user1._id !== user._id) {
      toast({
        title: "Only admins can remove someone!",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      return;
    }

    try {
      setLoading(true);
      const config = {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      };
      const { data } = await axios.put(
        `${ENDPOINT}/api/chat/groupremove`,
        {
          chatId: selectedChat._id,
          userId: user1._id,
        },
        config
      );

      user1._id === user._id ? setSelectedChat() : setSelectedChat(data);
      setFetchAgain(!fetchAgain);
      fetchMessages();
      setLoading(false);
    } catch (error) {
      toast({
        title: "Error Occured!",
        description: error.response.data.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setLoading(false);
    }
    setGroupChatName("");
  };

  return (
    <>
      <IconButton display={{ base: "flex" }} 
        // icon={<ViewIcon />}
        icon={<GroupIcon w={'30px'}/>}
        onClick={onOpen}  
        background={"#FFFFFF91"}
        backdropFilter={"blur(4px)"}
        color={'#868686'}
        border = {`1px solid #868686`}
        borderRadius={'10px 0px 10px 0px'}
         borderBottom={'none'}
         borderLeft={'none'}
        
        
        />

      <Modal size="md" onClose={onClose} isOpen={isOpen} isCentered  
        >
        <ModalOverlay />
        <ModalContent  
        backgroundImage={"url('./assets/BodyBG.png')"}
        backgroundSize={"cover"}
        boxShadow={'bxshd.inset_blk'}
        borderRadius={"10px 10px 10px 10px"}
        >
          <ModalHeader
            fontSize="35px"
            fontFamily="Gilroy"
            display="flex"
            justifyContent="center"
            bg={'white'}
            borderRadius={"10px 10px 0 0"}
            background={"url('./assets/BodyBG2.png')"}
            backgroundSize={'cover'}
            boxShadow={'bxshd.inset_blk'}
            color ={"#868686"}
          >
            {selectedChat?.chatName}
          </ModalHeader>

          <ModalCloseButton />
          <ModalBody display="flex" flexDir="column" alignItems="center">
                    <Box
        display="flex"
        flexDir="column"
        p={3}
        // bg="rgba(250,250,250,0.2)"  
        bg="rgba(250,250,250,0.9)"  
        backgroundImage={"url('./assets/BodyBG2.png')"}
        // bg="#F8F8F8"  
        w="100%"
        h="100%"
        borderRadius="10px 0 10px 10px"
        overflowY="hidden"
        // backgroundImage={"url('./assets/BodyBG.png')"}
        // backgroundColor={"bgs.accntBx"}
        boxShadow={"bxshd.inset_blk"}
         backdropFilter={"blur(2px)"} 
         justifyContent={'center'}
         textAlign={'center'}
      >
           
            <Box w="100%" display="flex" flexWrap="wrap" pb={3}>
              {selectedChat?.users.map((u) => (
                <UserBadgeItem
                  key={u?._id}
                  user={u}
                  boxShadow={"bxshd.userBdg"}

                  admin={selectedChat?.groupAdmin}
                  handleFunction={() => handleRemove(u)}
                />
              ))}
            </Box>
            <FormControl display="flex">
              <Input
                placeholder="Chat Name"
                mb={3}
                value={groupChatName}
                onChange={(e) => setGroupChatName(e.target.value)}
                backdropFilter={"blur(4px)"}
                border = {`1px solid #868686`}
                               _placeholder={{ opacity: 0.7, color: '#868686' }}

              />
              <Button
                variant="solid"
                colorScheme="teal"
                boxShadow={'bxshd.userBdg'}
                borderRadius = "0px 5px 5px 10px"
                ml={1}
                p={3}
                margin={'2px 10px'}
                isLoading={renameloading}
                onClick={handleRename}
              >
                Update
              </Button>
            </FormControl>
            <FormControl>
              {/* <label>add user</label> */}
              <Input
                placeholder="Add User to group"
                mb={1}
                onChange={(e) => handleSearch(e.target.value)}
                backdropFilter={"blur(4px)"}
                border = {`1px solid #868686`}
                _placeholder={{ opacity: 0.9, color: '#868686' }}
                
              />
            </FormControl>

            {loading ? (
              <Spinner size="lg" />
            ) : (
              searchResult?.map((user) => (
                <UserListItem
                  key={user._id}
                  user={user}
                  handleFunction={() => handleAddUser(user)}
                />
              ))
            )}
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button
             boxShadow={'bxshd.userBdg'}
             borderRadius = "10px 0px 10px 0px"
             onClick={() => handleRemove(user)} colorScheme="red">
              Leave Group
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default UpdateGroupChatModal;